import {
    CONFIRMED_GET_FEATURES
} from '../actions/Feature/FeatureTypes';
const initialState = {
    feature: [],
    loading: false,
};

function FeatureReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'FEATURE_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_FEATURES:
            return {
                ...state,
                feature: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {FeatureReducer};